import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { DeleteChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/delete-charge-point.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useDeleteChargePointContext } from '../../charge-point.context';
import { ChargePointDeleteFormStep1Controller } from '../charge-point-delete-form-step-1/charge-point-delete-form-step-1.controller';

export interface ChargePointDeleteFormControllerProps {
  onError: SubmitErrorHandler<Pick<DeleteChargePointModel, 'id'>>;
  onSubmit: SubmitHandlerWithDirtyFields<Pick<DeleteChargePointModel, 'id'>>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const ChargePointDeleteFormController = (
  props: ChargePointDeleteFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useDeleteChargePointContext();

  return (
    <MultiStepFormProvider<Pick<DeleteChargePointModel, 'id'>>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['id'],
          component: <ChargePointDeleteFormStep1Controller />,
        },
      ]}
    />
  );
};
